/*
 * @Author: wuqinfa
 * @Date: 2022-11-22 16:00:25
 * @LastEditors: wuqinfa
 * @Description: 
 */
import { message as antdMess } from 'antd';

import type { MxcApiRes } from './interface';

antdMess.config({ maxCount: 1 });

export default function showErrorMessage(mxcApiRes: MxcApiRes) {
  const {
    code = '',
    message = '',
  } = mxcApiRes || {};
  let showMessage: MxcApiRes['message'] = message;
  console.log('showMessage :>> ', showMessage);

  // switch (code) {
  //   case '40700':
  //   case '50000':
  //   case '000006':
  //   case '000500':
  //   case '000407':
  //     showMessage = message;
  //     break;
  //   case '40100':
  //   case '40300':
  //   default:
  //     break;
  // }

  if (showMessage) {
    antdMess.error(showMessage);
  }
}